import { useEffect, useCallback, useState } from 'react';
import APIEndpoints from '../../../../api/APIEndpoints';
import { axiosInstance } from '../../../../../api/axios';
import moment from 'moment';

const filterKeys = ['userid', 'actiontype', 'usertype', 'fromdate', 'todate'];

const useEnumerationAuditList = (filters) => {
  const [auditData, setAuditData] = useState(null);
  const [auditDataFetching, setAuditDataFetching] = useState(true);
  const [error, setError] = useState(false);
  const [userOptions, setUserOptions] = useState([]);

  const getAuditListData = useCallback(
    async (pagination, isReset) => {
      setAuditDataFetching(true);

      const queryParams = [];

      if (!isReset) {
        filterKeys.forEach((key) => {
          if (filters[key] && filters[key] !== 'All') {
            queryParams.push(`${key}/${filters[key]}`);
          }
        });
      }

      for (const key in pagination) {
        if (pagination[key]) {
          queryParams.push(`${key}/${pagination[key]}`);
        }
      }

      const finalUrl = `${APIEndpoints.getEnumerationAuditLog()}${queryParams.join(
        '/',
      )}`;
      let auditResponse = null;
      try {
        setError(false);
        const auditLog = await axiosInstance.get(finalUrl);
        auditResponse = auditLog?.data;
      } catch (error) {
        console.log('Error fetching enumeration Audit log', error);
        setError(true);
      } finally {
        setAuditData(auditResponse);
        if (!userOptions?.length) {
          setUserOptions(auditResponse?.ListOfUserDetails);
        }
        setAuditDataFetching(false);
      }
    },
    [filters, userOptions],
  );

  const downloadAuditListData = useCallback(async () => {
    const queryParams = [];
    filterKeys.forEach((key) => {
      if (filters[key] && filters[key] !== 'All') {
        queryParams.push(`${key}/${filters[key]}`);
      }
    });

    const finalUrl = `${APIEndpoints.getEnumerationAuditLogDownload()}${queryParams.join(
      '/',
    )}`;
    try {
      const auditLog = await axiosInstance.get(finalUrl, {
        responseType: 'blob',
      });
      const blob = new Blob([auditLog.data]);

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');

      link.href = url;

      link.setAttribute(
        'download',
        `audit-log-${moment().format('YYYYMMDD-HHmmss')}.xlsx`,
      );
      document.body.appendChild(link);

      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log('Error downloading enumeration Audit log', error);
    }
  }, [filters]);

  useEffect(() => {
    getAuditListData({
      pagenumber: 1,
      pagesize: 10,
    });
  }, []);

  return {
    auditData,
    auditDataFetching,
    getAuditListData,
    downloadAuditListData,
    userOptions,
    error,
  };
};

export default useEnumerationAuditList;
